module.exports = __webpack_public_path__ + "static/img/home8.6e57bfe5.png";